/**
 * DetailHeaderBits.jsx — shared bits of a "Velzon profile-wid" detail page header
 * (avatar initials + the small StatBox counter), extracted from FirmaDetayPage.jsx
 * (backlog #51, 2026-09-20) so FuarAlaniDetayPage can use the same header pattern
 * without duplicating them.
 */

/** İki kelimenin baş harfleri, tek kelimeyse ilk iki harfi — avatar rozeti için. */
export function initials(name) {
  const words = String(name || "").trim().split(/[\s.]+/).filter((w) => /[\p{L}\p{N}]/u.test(w));
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toLocaleUpperCase("tr-TR");
  return (words[0][0] + words[1][0]).toLocaleUpperCase("tr-TR");
}

/** Başlıktaki küçük sayaç kutusu. */
export function StatBox({ icon, value, label }) {
  return (
    <div className="d-flex align-items-center gap-2">
      <div className="avatar-xs flex-shrink-0">
        <span className="avatar-title rounded bg-light text-body fs-15">
          <i className={`bx ${icon}`} />
        </span>
      </div>
      <div>
        <h6 className="mb-0 fs-15">{value}</h6>
        <p className="text-muted mb-0 fs-11">{label}</p>
      </div>
    </div>
  );
}
